let errorActions = null;

export function dataURLToBlob(dataURL) {
  var BASE64_MARKER = ';base64,';
  if (dataURL.indexOf(BASE64_MARKER) == -1) {
    var parts = dataURL.split(',');
    var contentType = parts[0].split(':')[1];
    var raw = decodeURIComponent(parts[1]);

    return new Blob([raw], { type: contentType });
  }

  var parts = dataURL.split(BASE64_MARKER);
  var contentType = parts[0].split(':')[1];
  var raw = window.atob(parts[1]);
  var rawLength = raw.length;

  var uInt8Array = new Uint8Array(rawLength);

  for (var i = 0; i < rawLength; ++i) {
    uInt8Array[i] = raw.charCodeAt(i);
  }

  return new Blob([uInt8Array], { type: contentType });
}

export function showError(error) {
  if (errorActions) {
    errorActions.showError(error);
  }
}

export function setErrorActions(actions) {
  errorActions = actions;
}

export function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

export function convertBase64ToImage(array) {
  try {
    return array?.map(element => isBase64(element) ? "data:image/png;base64," + element : element);
  } catch (error) {
    console.error(error);
    return null;
  }
    function isBase64(element) {
      const base64Regex = /^[A-Za-z0-9+/]+={0,2}$/;
      return base64Regex.test(element);
  }
}

export function getHolderNameHidden(name) {
  return name
    ? name.split(' ').reduce((result, nameSplit) => {
        return `${result}${maskFirst(nameSplit)} `;
      }, '')
    : '';

  function maskFirst(text) {
    return `${text.charAt(0)}${Array(text.length).join('*')}`;
  }
}

export function normalizeText(text) {
  return text
    ?.normalize('NFD')
    .replace(/([aeio])\u0301|(u)[\u0301\u0308]/gi, '$1$2')
    .replace(/\s/g, '')
    .toLowerCase();
}

export function validateEmail(email) {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
}

export const generateUniqueId = () => Math.random().toString(36).slice(2);
